import React from "react";
import PageHeader from "../../../components/headers/PageHeader";
import castel from "../../../assets/Images/castel.jpg";
import "./MedicalDevice.css";
import { Link } from "react-router-dom";
import Flag from "react-world-flags";

export default function MedicalDevice() {
    return (
        <div className="meddev-page">
            <PageHeader
                mediaSrc={castel}
                mediaType="image"
                title="Medical Device"
                slogan=""
            />

            <section className="meddev-section meddev-introSection">
                <h2>Medical Device Regulatory Affairs</h2>

                <p>
                    Discover a wide array of advanced medical devices designed to meet
                    the highest standards of safety and efficacy. Our selection includes
                    products meticulously engineered to support healthcare professionals
                    and enhance patient care across diverse medical fields.
                </p>

                <p>
                    Our commitment to excellence is underscored by adherence to
                    international standards and protocols, ensuring every device in our
                    range is certified and compliant with respected regulatory bodies
                    across global markets.
                </p>
            </section>

            <section className="meddev-section">
                <h2>Regulatory Solutions for a Healthier Tomorrow</h2>

                <p>
                    Delivering end-to-end regulatory support for medical devices and IVDs
                    — from concept to commercialization. Eupraxia’s Regulatory Affairs
                    team in India ensures full compliance with CDSCO, EU MDR 2017/745,
                    and USFDA requirements through structured documentation, technical
                    depth, and seamless coordination with global partners.
                </p>
            </section>

            <section className="meddev-section meddev-servicesSection">
                <h2>Navigating the Regulatory Landscape for Medical Devices</h2>

                <p className="meddev-sectionIntro">
                    We offer a comprehensive suite of medical device regulatory affairs
                    services to guide innovations from concept to market with compliant,
                    efficient, and strategic regulatory solutions.
                </p>

                <article className="meddev-card">
                    <h3>Our Services</h3>

                    <ul className="meddev-list meddev-list--twoCol">
                        <li>Authorized Representative / Indian Agent services for foreign manufacturers.</li>
                        <li>Regulatory strategy and classification consultation for devices and IVDs.</li>
                        <li>Medical Device License applications — Manufacturing, Import, and Wholesale.</li>
                        <li>Technical File and Design Dossier compilation per CDSCO and EU MDR standards.</li>
                        <li>Clinical Evaluation Report and Performance Evaluation Report preparation.</li>
                        <li>Product registration, market authorization, and Free Sale Certificate support.</li>
                        <li>ISO 13485 certification, CE Marking, and USFDA 510(k), De Novo, and PMA submissions.</li>
                        <li>Labeling and IFU compliance per Indian and global regulatory guidelines.</li>
                        <li>Post-Market Surveillance, vigilance reporting, and recall documentation.</li>
                        <li>End-to-end lifecycle management — registration, renewal, and regulatory maintenance.</li>
                        <li>Regulatory pathway assessment and predicate device analysis.</li>
                        <li>CDSCO application preparation and submission.</li>
                        <li>Compilation of Device Master File and Plant Master File.</li>
                        <li>Technical File and Design Dossier development per MDR Annex II and III.</li>
                        <li>Import, manufacturing, and wholesale license coordination with CDSCO.</li>
                        <li>PMS, vigilance, and field safety corrective action documentation.</li>
                        <li>Labeling/IFU compliance and global harmonization review.</li>
                        <li>FSC, export NOC, and market authorization support.</li>
                        <li>Regulatory gap analysis and remediation planning for legacy devices.</li>
                        <li>Device change notification, license amendment, and renewal management.</li>
                        <li>Query response and deficiency management during authority review.</li>
                        <li>Coordination with laboratories and notified bodies for testing and conformity assessment.</li>
                        <li>Integration of Regulatory, Quality, and CSV deliverables into audit-ready documentation.</li>
                    </ul>
                </article>
            </section>

            <section className="meddev-section meddev-offerSection">
                <h2>What We Offer</h2>

                <div className="meddev-regGrid">
                    <Link
                        to="/MedicalDevice/UsFDA"
                        className="meddev-regCard"
                        aria-label="USA FDA"
                    >
                        <header className="meddev-regHead">
                            <Flag code="US" className="meddev-regFlag" title="United States" />
                            <h3>USA FDA</h3>
                        </header>

                        <p>
                            510(k), De Novo, and PMA submissions, labeling/IFU compliance,
                            and robust PMS and vigilance documentation.
                        </p>
                    </Link>

                    <Link
                        to="/MedicalDevice/EU"
                        className="meddev-regCard"
                        aria-label="EU MDR"
                    >
                        <header className="meddev-regHead">
                            <Flag code="EU" className="meddev-regFlag" title="European Union" />
                            <h3>EU MDR</h3>
                        </header>

                        <p>
                            CE-marking support under EU MDR 2017/745, including Technical
                            File, Clinical Evaluation Report, and notified body coordination.
                        </p>
                    </Link>

                    <Link
                        to="/MedicalDevice/CDSCO"
                        className="meddev-regCard"
                        aria-label="India CDSCO"
                    >
                        <header className="meddev-regHead">
                            <Flag code="IN" className="meddev-regFlag" title="India" />
                            <h3>India CDSCO</h3>
                        </header>

                        <p>
                            Manufacturing, import, and wholesale licenses, Indian Agent
                            services, and end-to-end dossier preparation.
                        </p>
                    </Link>
                </div>
            </section>
        </div>
    );
}